import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'm-statistics-card',
  template: `
    <nz-card class="m-statistics-card" [style.borderColor]="mBorderColor">
      <img class="m-statistics-card-avatar" [attr.src]="mImg" />
      <div class="m-statistics-card-right-content">
        <div class="m-statistics-card-title-desc">{{ mNumber }}</div>
        <div class="m-statistics-card-title-content">{{ mTitle }}</div>
      </div>
    </nz-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class StatisticsCardComponent {
  @Input() mImg = '';
  @Input() mNumber = 0;
  @Input() mTitle = '';
  @Input() mBorderColor = '#abc';
}
